<template>
  <div class="layout-box">
    <LayoutHeader headtitle="数字印染分析" :permissions="[1]"></LayoutHeader>
    <div class="secondary-content">
      <div class="secondary_l">
        <h3 style="margin-top: 70px">产量浮动情况</h3>
        <div id="chartline" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)" style="min-height: 249px; padding: 0 50px; box-sizing: border-box"></div>
        <div style="display: flex;justify-content: space-around;width: 100%; margin-top: 10px">
          <div style="width: 50%; height: 259px" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
            <instrument :configs="myconfig" ref="myconfig"></instrument>
          </div>
          <div style="width: 50%; height: 259px" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
            <instrument :configs="myconfig2" ref="myconfig2"></instrument>
          </div>
        </div>
        <h3 style="margin-top: -10px">服务品类</h3>
        <div class="content-cloud">
          <div class="tagcloud fl">
            <a style="background: #02D088;">服装饰品</a><!--radial-gradient(#FADF0E,#02D088)-->
            <a style="background: linear-gradient(to bottom left,#F12655,#154EF7)">混纺</a>
            <a style="background: #F72552">化纤面料</a><!--radial-gradient(#04CB9E,#F72552)-->
            <a style="background: #154EF7">纺织品</a><!--linear-gradient(#F7BB0D,#EF0003)-->
            <a style="background: linear-gradient(to bottom left,#FF2524,#442243)">轻工日用品</a>
            <a style="background: radial-gradient(#BC4DFF,#FF7EF9)">交织类面料</a>
            <a style="background: linear-gradient(#A02EFF,#0BB0D5)">里料</a>
            <a style="background: #FD6F4F">化工</a><!--linear-gradient(to bottom left,#FD6F4F,#0AB4D1)-->
            <a style="background: #003EBE">化纤面料</a><!--linear-gradient(#E9425C,#003EBE)-->
          </div>
        </div>
      </div>
      <div class="secondary_c">
        <div style="height: 580px;" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
          <echartschina :configs="myconfigchina" ref="child"></echartschina>
        </div>
        <div style="height: 280px;margin-top: 24px; display: flex; justify-content: space-between;">
          <div style="width: 50%; height: 100%" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <Echartring :configs="myconfigring1" ref="myconfigring1"></Echartring>
          </div>
          <div style="width: 50%; height: 100%" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <Echartring :configs="myconfigring2" ref="myconfigring2"></Echartring>
          </div>
        </div>
      </div>
      <div class="secondary_r">
        <h3 style="margin-top: 70px">本月能耗情况</h3>
        <p style="display: flex; justify-content: space-between;margin-top: 15px;padding: 0 50px; box-sizing: border-box; color: #EFF3FC;font-size: 14px">
          <span>水耗 <a style="font-size: 12px">行业标准<=1.6吨/百米</a></span><span><a style="font-size: 12px">国家标准<=30kgce</a> 综合能耗</span>
        </p>
        <div id="chartline2" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)" style="min-height: 225px; padding: 0 50px; box-sizing: border-box"></div>
        <h3 style="margin-bottom: -5px; margin-top: 20px">本月100米标煤能耗占比</h3>
        <div style="height: 260px; padding: 0 60px; box-sizing: border-box" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
          <Echartring :configs="myconfigring3" ref="myconfigring3"></Echartring>
        </div>
        <h3 style="margin-top: 0; margin-bottom: -10px">上月开工率</h3>
        <div id="chartbar" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)" style="min-height: 235px; padding: 0 50px; box-sizing: border-box"></div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/views/homeManage/module/tagcloud.js'
import LayoutHeader from "../layout/layout-header2";
import echartschina from "../../components/china";
import instrument from "../../components/echart-instrument"
import Echartring from "../../components/echart-ring"
export default {
  name: "printing-dyeing-analysis",
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader,
    echartschina,
    instrument,
    Echartring
  },
  data () {
    return {
      myconfig:{
        id:'num1',
        datawidth:15,
        formatter:`{value}%`,
        name:'设备OEE',
        value:0,
        datacolor:[
          [0.3, '#fd666d'],
          [0.7, '#37a2da'],
          [1, '#67e0e3']
        ]
      },
      myconfig2:{
        id:'num2',
        value:0,
        datawidth:15,
        name:'成本占比',
        formatter:`{value}%`,
        datacolor:[
          [0.3, '#67e0e3'],
          [0.7, '#37a2da'],
          [1, '#fd666d']
        ]
      },
      myconfigchina:{
        formatter:function(e, t, n) {
          let data = e.data;
          // //模拟数据
          // data.specialImportant = Math.random()*1000 | 0;
          // data.import = Math.random()*1000 | 0;
          // data.compare = Math.random()*1000 | 0;
          // data.common = Math.random()*1000 | 0;
          let context=''
          if(data){
            context = `
               <div>
                   <p><b style="font-size:15px;">${data.name}</b></p>
                   <p class="tooltip_style"><span class="tooltip_left">企业家数</span><span class="tooltip_right">${data.value}家</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">销售收入</span><span class="tooltip_right">${data.salesAmount}万元</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">服装工业园区 </span> <span class="tooltip_right">${data.industrialzoneCount}个</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">服装市场</span><span class="tooltip_right">${data.marketCount}个</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">服装总产量</span><span class="tooltip_right">${data.totalOutput}万件</span></p>
               </div>
            `
          }

          return context;
        },
        title:{
          text: '服装产业集聚地',
          textStyle:{
            color:'#F4F7FF',
            fontSize:'18px'
          },
          top: 100,
          left: 'center'
        },
        top:110,
        pieces: [
          { gte: 8000, label: "", color: "#9E363E" },
          { gte: 6000, lt: 7999, label: "", color: "#C0464E" },
          { gte: 3000, lt: 5999, label: "", color: "#C34D51" },
          { gte: 1000, lt: 2999, label: "", color: "#C65456" },
          { gte: 500, lt: 999, label: "", color: "#CD6662" },
          { gte: 200, lt:499, label: "", color: "#D5796E" },
          { gte: 100, lt: 199, label: "", color: "#E09F81" },
          { gte: 10, lt: 99, label: " ", color: "#EAC292" },
          { lt:10, label:' ', color: "#F0D89C" }
        ],
        areaColor:'#E8E8C8',
        dataList:[{
              name: "南海诸岛",
              value: 0,
              salesAmount:0,
              industrialzoneCount:0,
              marketCount:0,
              totalOutput:0
            }],
      },
      myconfigring1:{
        id:'num1',
        text:'行业6大印染 区域分布',
        seriesdata:[],
        name:'区域分布'
      },
      myconfigring2:{
        id:'num2',
        text:'六大服装产业集聚地',
        seriesdata:[],
        name:'集聚地'
      },
      myconfigring3:{
        id:'num3',
        titleshow:false,
        seriestop:'3%',
        seriesleft:'5%',
        seriesdata:[],
        name:'能耗占比'
      },
      loading:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted() {
    let $this=this
    tagcloud({
      selector: ".tagcloud",  //元素选择器
      fontsize: 16,       //基本字体大小, 单位px
      radius: 100,         //滚动半径, 单位px
      radiusHeight: 'aotu',         //设置高度, 单位px
      mspeed: "normal",   //滚动最大速度, 取值: slow, normal(默认), fast
      ispeed: "normal",   //滚动初速度, 取值: slow, normal(默认), fast
      direction: 135,     //初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...
      keep: false          //鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动
    });
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.getdata()
    })
  },
  methods:{
    getdata () {
      const $this=this
      const url = '/api-portal/dm/weekYield';
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          const day = dataall.day
          const abbr104 = dataall.abbr104
          const abbr105 = dataall.abbr105
          const abbr108 = dataall.abbr108
          const data1= new Array(day.length).fill('0')
          const data2= new Array(day.length).fill('0')
          const data3= new Array(day.length).fill('0')
          abbr104.map(vals=>{
            const index = day.findIndex(v => v === vals.dateStr)
            if(index>=0){
              data1.splice(index, 1, (vals.monAvg).toFixed(2))
            }
          })
          abbr105.map(vals=>{
            const index = day.findIndex(v => v === vals.dateStr)
            if(index>=0){
              data2.splice(index, 1, (vals.monAvg).toFixed(2))
            }
          })
          abbr108.map(vals=>{
            const index = day.findIndex(v => v === vals.dateStr)
            if(index>=0){
              data3.splice(index, 1, (vals.monAvg).toFixed(2))
            }
          })
          let yrDict1=day.map(vals=>{
            return vals.substring(5)
          })
          this.drawlinediagram(data1,data2,data3,yrDict1)
          this.loading=false
        }
      });
      const url2 = '/api-portal/dm/mapData';
      this.$api.get(url2, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.myconfigchina.dataList=dataall.map
          this.$refs.child.setEchartOption()
          this.$refs.child.initEchartMap()
          $this.myconfigring2.seriesdata=dataall.gather
          $this.myconfigring1.seriesdata=dataall.dyeing
          this.$refs.myconfigring1.echartring()
          this.$refs.myconfigring2.echartring()
          $this.loading3=false
        }
      });
      const url3 = '/api-portal/dm/oneEnergyData';
      this.$api.get(url3, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.myconfigring3.seriesdata.push({name:'电',value:dataall.abbr110.monAvg||0})
          $this.myconfigring3.seriesdata.push({name:'中压蒸汽',value:dataall.abbr111.monAvg||0})
          $this.myconfigring3.seriesdata.push({name:'低压蒸汽',value:dataall.abbr112.monAvg||0})
          $this.myconfigring3.seriesdata.push({name:'天然气',value:dataall.abbr113.monAvg||0})
          this.$refs.myconfigring3.echartring()
          $this.loading4=false
        }
      });
      const url4 = '/api-portal/dm/monthEnergy';
      this.$api.get(url4, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          const yrDict = dataall.yrDict
          const abbr101 = dataall.abbr101
          const abbr102 = dataall.abbr102
          const abbr103 = dataall.abbr103
          const data1= new Array(yrDict.length).fill('0')
          const data2= new Array(yrDict.length).fill('0')
          const data3= new Array(yrDict.length).fill('0')

          abbr101.map(vals=>{
            const index = yrDict.findIndex(v => v.code === vals.category)
            if(index>=0){
              data1.splice(index, 1, (vals.monAvg).toFixed(2))
            }
          })
          abbr102.map(vals=>{
            const index = yrDict.findIndex(v => v.code === vals.category)
            if(index>=0){
              data2.splice(index, 1, (vals.monAvg).toFixed(2))
            }
          })
          abbr103.map(vals=>{
            const index = yrDict.findIndex(v => v.code === vals.category)
            if(index>=0){
              data3.splice(index, 1, (vals.monAvg*100).toFixed(2))
            }
          })
          let yrDict1=yrDict.map(vals=>{
            return vals.abbr
          })
          $this.drawlinediagram2(data1,data2,yrDict1);
          $this.drawbarchart(data3,yrDict1)
          $this.loading5=false
        }
      })
      const url5 = '/api-portal/dm/equipmentOEEData';
      this.$api.get(url5, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.myconfig.value=dataall.abbr109.monAvg.toFixed(2)
          $this.myconfig2.value=dataall.abbr107.monAvg.toFixed(2)
          this.$refs.myconfig.drawline2diagram()
          this.$refs.myconfig2.drawline2diagram()
          $this.loading2=false
        }
      });
    },
    drawlinediagram (data1,data2,data3,data4) {
      const myEchartst = this.$echarts.init(document.getElementById('chartline'))
      let option = {

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data4
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '产值浮动率',
            type: 'line',
            smooth: true,
            data: data3,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#0DAC97'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            lineStyle: {
              color: '#0DAC97'
            },
            color: '#0DAC97'
          },{
            name: '白坯浮动率',
            type: 'line',
            smooth: true,
            data: data2,
            lineStyle: {
              color: '#FDDD60'
            },
            color: '#FCCF1B'
          },{
            name: '成品浮动率',
            type: 'line',
            smooth: true,
            data: data1,
            lineStyle: {
              color: '#F72552'
            },
            color: '#CF0734'
          }
        ]
      }
      myEchartst.setOption(option)
    },
    drawlinediagram2(data1,data2,data3){
      const myEchartst = this.$echarts.init(document.getElementById('chartline2'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data3
        },
        yAxis: [{
          type: 'value',
          splitLine: {
            show:false,
            // lineStyle: {
            //   color: '#2345AB'
            // }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },{
          type: 'value',
          splitLine: {
            show:false,
            // lineStyle: {
            //   color: '#2345AB'
            // }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        }],
        series: [
          {
            data: data1,
            type: 'line',
            name: '水耗',
            yAxisIndex:0,
            showSymbol: false,
            lineStyle: {
              color: '#F302FB'
            },
            color: '#F302FB',
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(243, 2, 251,1)'
                },
                {
                  offset: 0.6,
                  color: 'rgba(243, 2, 251,0.8)'
                },
                {
                  offset: 1,
                  color: 'rgba(255, 255, 255,0)'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            }
          },
          {
            data: data2,
            type: 'line',
            name: '综合能耗',
            yAxisIndex:1,
            showSymbol: false,
            lineStyle: {
              color: '#F37B08'
            },
            color: '#F37B08',
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(243, 123, 8,1)'
                },
                {
                  offset: 0.6,
                  color: 'rgba(243, 123, 8,.8)'
                },
                {
                  offset: 1,
                  color: 'rgba(255, 255, 255,0.3)'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            }
          }
        ]
      };
      myEchartst.setOption(option)
    },
    drawbarchart (data1,data2) {
      const myEchartst = this.$echarts.init(document.getElementById('chartbar'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: data2
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '开工率',
            type: 'bar',
            data: data1,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#FF7F00'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#00D900'
                  }, {
                    offset: 1,
                    color: '#FF7F00'
                  }
                ]
              }
            }
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../assets/secondary/bg-1.jpg");
}

.secondary-content{
  width: 100%;
  height: 100%;
  padding: 35px 10px 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.secondary-content h3{
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  box-sizing: border-box;
  margin-left: 58px;
  margin-top: 25px;
}

.secondary_l{
  width: 583px;
  height: 933px;
  background: url("../../assets/secondary/border-l.png") no-repeat center/100%;
}

.secondary_c{
  flex: 1;
}

.secondary_r{
  width: 583px;
  height: 933px;
  background: url("../../assets/secondary/border-r.png") no-repeat center/100%;
}

.content-cloud{
  width: 483px;
  height: 261px;
  margin-left: 52px;
  overflow: hidden;
  background: url("../../assets/secondary/border-1.png") no-repeat center/100%;
}

.tagcloud {
  position: relative;
  overflow: hidden;
  padding: 10px 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.tagcloud a{
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  color: #fff;
  font-size: 16px;
  padding: 14px 16px;
  border-radius: 5px;
  text-align: center;
  background-color: #f2f4f8;
  font-family:"fzskjt";
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 6px 4px 8px 0 rgba(0,0,0,.34);
  text-shadow: 2px 4px 6px rgba(0,0,0,0.6);
  transition: font-size 0.9s ease-out;
  -webkit-transition: font-size 0.9s ease-out;
}
.tagcloud a:hover{
  font-weight: bold;
  font-size: 18px;
  transition: font-size 0s;
  -webkit-transition: font-size 0s;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/printing-dyeing-analysis.vue